export class ReadReceiptTracker {
  private confirmedThrough = 0
  private pendingThrough = 0
  private failedThrough = 0

  begin(throughSeq: number): number | null {
    const attemptedThrough = Math.max(
      this.confirmedThrough,
      this.pendingThrough,
      this.failedThrough,
    )
    if (throughSeq <= attemptedThrough)
      return null
    this.pendingThrough = throughSeq
    return throughSeq
  }

  succeed(throughSeq: number): void {
    this.confirmedThrough = Math.max(this.confirmedThrough, throughSeq)
    if (this.pendingThrough <= throughSeq)
      this.pendingThrough = 0
    if (this.failedThrough <= throughSeq)
      this.failedThrough = 0
  }

  reject(throughSeq: number): void {
    if (this.pendingThrough === throughSeq)
      this.pendingThrough = 0
    this.failedThrough = Math.max(this.failedThrough, throughSeq)
  }

  allowLifecycleRetry(): void {
    this.failedThrough = this.confirmedThrough
  }

  reset(): void {
    this.confirmedThrough = 0
    this.pendingThrough = 0
    this.failedThrough = 0
  }
}
